import type { Collection } from "@/shared/types";

export const COLLECTIONS: Collection[] = [
  { slug: "continue-watching", title: "Continue Watching", movieIds: ["m3","m5","m1","m9"] },
  { slug: "trending-now", title: "Trending Now", movieIds: ["m2","m1","m9","m6","m17","m20","m12","m11"] },
  { slug: "new-releases", title: "New Releases", description: "Out this week", movieIds: ["m1","m4","m9","m16","m19","m20","m24"] },
  { slug: "action", title: "Action & Thrillers", movieIds: ["m2","m6","m10","m17","m20"] },
  { slug: "drama", title: "Drama", movieIds: ["m1","m4","m11","m12","m15","m16","m21","m24","m7","m19"] },
  { slug: "documentaries", title: "Documentaries", movieIds: ["m8","m13","m18","m25"] },
  { slug: "k-drama", title: "Late-Night Picks", movieIds: ["m7","m11","m15","m19","m23"] },
];
